import {
  Box,
  Typography,
  FormLabel,
  TextField,
  Button,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import googleImg from "../../assets/landing_page/Images/googleImg.png";
import http from "../../utils/http-common";
import React, { useState } from "react";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import Logo from "../../assets/landing_page/Planshare.png";
import {VisibilityOutlined as VisibilityOutlinedIcon, VisibilityOffOutlined as VisibilityOffOutlinedIcon } from "@mui/icons-material";
export const Register = () => {
  const [user_name, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;
    // Name validation
    if (!user_name) {
      tempErrors.user_name = "Name is required.";
      isValid = false;
    }
    // Email validation
    if (!email) {
      tempErrors.email = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      tempErrors.email = "Email address is invalid.";
      isValid = false;
    }
   if (!password){
    tempErrors.password = "Password is required.";
    isValid = false;
   }
   if (!confirmPassword) {
    tempErrors.confirmPassword = "Confirm Password is required.";
    isValid = false;
   }
    if (isValid) {
    if (
      password.length < 6 || // Minimum 6 characters
      !/[0-9]/.test(password) || // At least 1 number
      !/[!@#$%^&*]/.test(password) // At least 1 special character
    ) {
      isValid = false;
      toast.error(
        "Enter a valid password with at least 6 characters, 1 number, and 1 special character."
      );
    }
  }
    if (!confirmPassword) {
      tempErrors.confirmPassword = "Enter Confirm password";
      isValid = false;
    } else if (password !== confirmPassword) {
      tempErrors.confirmPassword = "Password and Confirm password are not same";
      isValid = false;
    }
    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) Register();
  };
  const Register = async () => {
    // const { user_name, email, password, confirmPassword } = formData;

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const payload = { user_name, email, password };
      const response = await http.post("/auth_service/user/register", payload);

      if (
        response.data.message ===
        "User created successfully, welcome email sent"
      ) {
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message && response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        localStorage.setItem("field_email", email);
        setTimeout(() => {
          navigate("/Otp");
          localStorage.setItem("field_email", email);
        }, 2000);
      } else if (
        response.data.message === "User details updated successfully"

      ) {
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            User created successfully, welcome email sent
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        localStorage.setItem("field_email", email);
        setTimeout(() => {
          navigate("/Otp");
          localStorage.setItem("field_email", email);
        }, 2000);
      }
      else if (response.data.message === 'This user is already registered and cannot be added again.') {
        toast.error("Email is already registered, please try some other");
        //navigate("/home");
      }
      else {
        toast.error("Failed to create account.");
      }
    } catch (error) {
    console.error("Error creating account:", error);

    // ✅ Handle no internet / network failure
    if (error.message === "Network Error" || !error.response) {
      toast.error("No internet connection or server not reachable. Please try again later.");
      return;
    }

    // ✅ Handle timeout (if axios timeout configured)
    if (error.code === "ECONNABORTED") {
      toast.error("The request timed out. Please try again.");
      return;
    }

    // ✅ Handle server-side errors
    const serverMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error creating account. Please try again.";

    toast.error(serverMessage);
  }
};
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundImage: `url('./background.jpg')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "rgba(255, 255, 255, 0.2)", // White overlay with 50% opacity
    backgroundBlendMode: "overlay",
      }}>
      <Box
        sx={{
          width: { xs: "80%", md: "27%" },
          border: "1px solid #E7E8EA",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          background: "#FFFFFF",
          borderRadius: "12px",
          p: "20px",
        }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
                src={Logo}
                alt='planshare logo'
                onClick={()=>(window.location.href = "https://planshare.ai")}
                style={{ width: "140px", height: "32px", cursor: "pointer" }}
              />
        </Box>
        <Typography
          sx={{
            my: 1,
            fontWeight: "600",
            fontSize: "20px",
            color: "#040815",
          }}>
          Sign Up and Get Organized!
        </Typography>
        <Typography
          sx={{ fontWeight: "500", fontSize: "16px", color: "#47474799" }}>
          Start your journey by creating your account.
        </Typography>
        <Box
          sx={{
            my: 2,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
            Name
          </FormLabel>
          <TextField
            placeholder='Enter Name'
            value={user_name}
            onChange={(e) => setUserName(e.target.value)}
            error={!!errors.user_name}
            helperText={errors.user_name}
            sx={{
              my: 1,
              "& input": {
                height: "10px",
              },
            }}></TextField>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
            Email
          </FormLabel>
          <TextField
            placeholder='Enter Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            sx={{
              my: 1,
              "& input": {
                height: "10px",
              },
            }}></TextField>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
            Password
          </FormLabel>
          <OutlinedInput
            placeholder='Enter Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!errors.password}
            helperText={errors.password}
            type={showPassword1 ? "text" : "password"}
            sx={{
              my: 1,
              "& input": {
                height: "10px",
              },
            }}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={() => setShowPassword1(!showPassword1)}
                  edge='end'>
                  {showPassword1 ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <VisibilityOutlinedIcon />
                  )}
                </IconButton>
              </InputAdornment>
            }
            label='Password'
          />
           <Box sx={{ my: 2, marginTop :-1,marginLeft :2}}>
         {errors.password && (
    <FormHelperText error>{errors.password}</FormHelperText>
  )}
  </Box>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
            Confirm Password
          </FormLabel>
          <OutlinedInput
            placeholder='Re-Enter Password'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            type={showPassword2 ? "text" : "password"}
            sx={{
              my: 2,
              "& input": {
                height: "10px",
              },
            }}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={() => setShowPassword2(!showPassword2)}
                  edge='end'>
                  {showPassword2 ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <VisibilityOutlinedIcon />
                  )}
                </IconButton>
              </InputAdornment>
            }
            label='Password'
          />
           <Box sx={{ my: 2, marginTop :-2,marginLeft :2}}>
         {errors.confirmPassword && (
    <FormHelperText error>{errors.confirmPassword}</FormHelperText>
  )}
  </Box>
          <Button
            sx={{
              background: "#FF2800",
              color: "#FFFFFF",
              textTransform: "capitalize",
              fontSize: "14px",
              fontWeight: "600",
              "&:hover": {
                background: "#e64a19",
              },
            }}
            onClick={handleSubmit}>
            Create Account
          </Button>
          <Typography
            sx={{
              color: "#0F1419",
              textAlign: "center",
              fontWeight: "400",
              fontSize: "12px",
              my: 1,
            }}>
            Already have an account?{" "}
            <Link
              to={"/Login"}
              style={{
                fontWeight: "600",
                fontSize: "12px",
                position: "relative",
                color: "#FF2800",
                textDecoration: "none", // Remove default underline
                borderBottom: "1px solid #FF2800", // Set the color and thickness of the
              }}>
              Login
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
